var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'About CMMC'
    }
  })], 1)], 1), _c('section', {
    staticClass: "section portfolio-section",
    attrs: {
      "id": "portfolio"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-12 py-4"
  }, [_vm._m(0), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "7"
    }
  }, [_c('p', [_vm._v(" The lowest level of security controls a government contractor must have in place to protect Federal Contract Information (FCI). All DIB contractors and subcontractors require at least CMMC Level 1 compliance to do business with the DoD. Level 1 demonstrates that an organization has the basic security controls in place to protect FCI, which is not intended for public release. Level 1 has 17 practices that qualified government contractors should meet. ")])]), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('img', {
    staticClass: "img-fluid cmmc-image",
    attrs: {
      "src": require("../../assets/images/cyberimages/level1.png"),
      "alt": ""
    }
  })])], 1)], 1), _c('div', {
    staticClass: "col-12 py-4"
  }, [_vm._m(1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "7"
    }
  }, [_c('p', [_vm._v(" Level 2 is the transitional phase between basic security measures to protect FCI and the measures required for sound protection of CUI. This is the bridge between baseline requirements and the authorization to handle sensitive data. Reaching this level indicates that a contractor is working towards good cyber hygiene while continuing to establish the processes needed to protect CUI. To obtain this level, contractors must demonstrate they have 110 specific security practices in place. ")])]), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('img', {
    staticClass: "img-fluid cmmc-image",
    attrs: {
      "src": require("../../assets/images/cyberimages/level2.png"),
      "alt": ""
    }
  })])], 1)], 1), _c('div', {
    staticClass: "col-12 py-4"
  }, [_vm._m(2), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "7"
    }
  }, [_c('p', [_vm._v(" Organizations that have achieved CMMC Level 3 already possess the essential security controls necessary to safeguard sensitive data. At Level 3, an organization is required to establish, maintain, and resource a comprehensive plan that demonstrates effective management of activities related to practice implementation. This plan may encompass details such as mission objectives, project plans, resource allocation, mandatory training, and active engagement with relevant stakeholders. Building upon the security foundations of Levels 1 and 2, achieving Level 3 signifies that a contractor has successfully implemented 130 specific cybersecurity requirements. ")])]), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('img', {
    staticClass: "img-fluid cmmc-image",
    attrs: {
      "src": require("../../assets/images/cyberimages/level3.png"),
      "alt": ""
    }
  })])], 1)], 1)])]), _c('section', {
    staticClass: "section parallax-bg mb-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "z-index9 wow fadeIn",
    attrs: {
      "data-wow-duration": "1s"
    }
  }, [_c('h2', {
    staticClass: "text-white text-center"
  }, [_vm._v(" Check your CMMC Compliance Level ")]), _c('p', {
    staticStyle: {
      "color": "white",
      "text-align": "center"
    }
  }, [_vm._v(" Take our cyber readiness assessment to determine how prepared your business is to deal with cyber-attacks. ")]), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "outline-theme-btn",
    attrs: {
      "pill": "",
      "variant": "outline-light"
    },
    on: {
      "click": _vm.activateResourcesMenuItem
    }
  }, [_vm._v("Take Readiness Check")])], 1)])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("CMMC Level 1")]), _c('h2', [_vm._v("Basic Cybersecurity Practices")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("CMMC Level 2")]), _c('h2', [_vm._v("Intermediate Cybersecurity Practices")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("CMMC Level 3 ")]), _c('h2', [_vm._v("Advanced Cybersecurity Practices")])]);

}]

export { render, staticRenderFns }